/**
 * Needs to correspond with screen breakpoints in tailwind.config.js
 */
export default {
  'break-0': 0,
  'break-1': 640,
  'break-2': 768,
  'break-3': 1024,
  'break-4': 1440,
  'break-5': 1600,
};
